"use strict";
/**
 * @react-component Flow - returns a react component for the Flow
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var react_redux_1 = require("react-redux");
var constants_1 = require("../constants");
var PAGES = constants_1.default.PAGES, VIEWS = constants_1.default.VIEWS;
var flow_body_component_1 = require("./flow-body.component");
// props = { cancelUrl, header, isCloseXHidden, children }
function FlowModal(props) {
    var isNotificationsFlow, view = props.route.enter.view;
    if (view === PAGES.NOTIFICATIONS || view === PAGES.COOKIES || view === VIEWS.COOKIE_PREFS) {
        isNotificationsFlow = 'flowWideModalWrapper';
    }
    return (React.createElement("div", { className: 'vx_modal-flow vx_modalPrepToOpen vx_modalIsOpen modal-flow ' + isNotificationsFlow, id: 'mainModal', tabIndex: -1, "aria-labelledby": 'js_modalHeader' },
        React.createElement(flow_body_component_1.default, tslib_1.__assign({}, props))));
}
var ConnectedModal = react_redux_1.connect(function (state) { return state; })(FlowModal);
exports.default = ConnectedModal;
